import { useAllocationRuleGraphTableDataRetrieveSuspense } from "gen/endpoints/allocation-rule-graph-table/allocation-rule-graph-table";
import { AllocationRuleGraphUseMetadata } from "gen/model/allocationRuleGraphUseMetadata";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { DataTable } from "shared/components/table/data/DataTable";
import { GetLinkInfoForRowFn } from "shared/components/table/data/DataTableTypes";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const AllocationRuleGraphsTableContent: React.FC = () => {
  const { t } = useTranslation(["allocation"]);
  const { fundFamilyId } = useRequiredStringParams();
  const { data: tableData } =
    useAllocationRuleGraphTableDataRetrieveSuspense(fundFamilyId);

  const getLinkInfoForRow = useCallback<GetLinkInfoForRowFn>(
    ({ row }) => {
      const rowMetadata = row.data?.metadata as AllocationRuleGraphUseMetadata;
      if (rowMetadata.allocation_rule_graph_use_id) {
        return {
          type: "generic",
          to: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .fundStructure({})
            .fundFamilySetupAllocationRuleGraphAndUse({
              allocationRuleGraphId: rowMetadata.allocation_rule_graph_id,
              allocationRuleGraphUseId:
                rowMetadata.allocation_rule_graph_use_id,
            }).$,
        };
      } else {
        return {
          type: "generic",
          to: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .fundStructure({})
            .fundFamilySetupAllocationRuleGraph({
              allocationRuleGraphId: rowMetadata.allocation_rule_graph_id,
            }).$,
        };
      }
    },
    [fundFamilyId],
  );

  return (
    <TableBoxBody>
      <DataTable
        data={tableData}
        getLinkInfoForRow={getLinkInfoForRow}
        fillWidth={true}
        disablePinnedHeaderColumns={true}
        emptyStateProps={{
          title: t("allocation:graphTable.emptyTitle"),
        }}
      />
    </TableBoxBody>
  );
};
